import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, ACTIVE, COMPANIES, BALANCE, TAXI_SERVICE, NAME } =
	BASE_WIDTH_COLUMNS;

export enum ColumnId {
	Active = "active",
	Name = "name",
	Balance = "balance",
	BonusBalance = "bonusBalance",
	Company = "company",
	TaxiService = "taxiService",
	CreatedAt = "createdAt",
}

export const translationTablePath = "mainPage.accounts.carParks.columns.";

const accountsCarParks = makeTable({
	allIds: [
		ColumnId.Active,
		ColumnId.Name,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.CreatedAt,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.Active,
		ColumnId.Name,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.CreatedAt,
	],
	initialSortMethod: {
		column: ColumnId.CreatedAt,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.Active]: ACTIVE,
		[ColumnId.Name]: NAME,
		[ColumnId.Balance]: BALANCE,
		[ColumnId.BonusBalance]: BALANCE,
		[ColumnId.Company]: COMPANIES,
		[ColumnId.TaxiService]: TAXI_SERVICE,
		[ColumnId.CreatedAt]: DATE,
	},
	initialResizable: {
		[ColumnId.Active]: true,
		[ColumnId.Name]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.CreatedAt]: true,
	},
	initialSortable: {
		[ColumnId.Active]: true,
		[ColumnId.Name]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.CreatedAt]: true,
	},
});

export default accountsCarParks;
